import { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyTitle } from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';

const DisplayFeedback = ({ icon, title, text, actions, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('min-h-40 px-4 py-8 text-center', className);

	// Render
	return (
		<Empty className={rootClassName}>
			<EmptyContent>
				{icon && (
					<EmptyMedia>
						<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
					</EmptyMedia>
				)}
				{title && <EmptyTitle>{title}</EmptyTitle>}
				{text && <EmptyDescription>{text}</EmptyDescription>}
				{actions && <EmptyActions>{actions}</EmptyActions>}
			</EmptyContent>
		</Empty>
	);
};
export { DisplayFeedback };
